import { render, staticRenderFns } from "./ComponenteSolicitacaoHistorico.vue?vue&type=template&id=6f9fa854"
import script from "./ComponenteSolicitacaoHistorico.vue?vue&type=script&lang=js"
export * from "./ComponenteSolicitacaoHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports